(() => {
  'use strict';

  const popup = document.getElementById('cvGrowthPlanBundle');
  if (!popup) return;

  const panel = popup.querySelector('.cv-gpb__panel');
  const closeButtons = popup.querySelectorAll('[data-gpb-close]');
  const variantButtons = Array.from(popup.querySelectorAll('[data-gpb-main-variant]'));
  const gifts = Array.from(popup.querySelectorAll('[data-gpb-gift]'));
  const counter = popup.querySelector('[data-gpb-counter]');
  const summaryCount = popup.querySelector('[data-gpb-summary-count]');
  const summaryProducts = popup.querySelector('[data-gpb-summary-products]');
  const saving = popup.querySelector('[data-gpb-saving]');
  const packagePrice = popup.querySelector('[data-gpb-package-price]');
  const submit = popup.querySelector('[data-gpb-submit]');
  const submitLabel = popup.querySelector('[data-gpb-submit-label]');
  const spinner = popup.querySelector('[data-gpb-spinner]');
  const message = popup.querySelector('[data-gpb-message]');
  const mainImage = popup.querySelector('[data-gpb-main-image]');
  const mainPrice = popup.querySelector('[data-gpb-main-price]');
  const variantError = popup.querySelector('[data-gpb-variant-error]');
  const triggerValue = popup.dataset.triggerValue || 'growth-plan';
  const defaultSubmitLabel = submitLabel?.textContent.trim() || 'Tambah ke Keranjang';
  const target = Math.max(1, Number.parseInt(popup.dataset.giftTarget || '3', 10));
  const currency = popup.dataset.currency || 'IDR';
  const managerId = 'growth-plan-bundle';
  const configured = popup.dataset.mainProductConfigured === 'true' && gifts.length > 0;
  const quantities = new Map(gifts.map((gift) => [gift, 0]));
  let selectedVariant = null;
  let isOpen = false;
  let isSubmitting = false;
  let previousFocus = null;
  let bodyOverflowBeforeOpen = '';

  function totalQuantity() {
    return Array.from(quantities.values()).reduce((sum, quantity) => sum + quantity, 0);
  }

  function setMessage(text = '', type = '') {
    if (!message) return;
    message.textContent = text;
    message.classList.toggle('is-error', type === 'error');
    message.classList.toggle('is-success', type === 'success');
  }

  function formatMoney(cents) {
    const value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency,
        maximumFractionDigits: 0,
      }).format(value).replace(/\s/g, ' ');
    } catch (error) {
      return `Rp ${Math.round(value).toLocaleString('id-ID')}`;
    }
  }

  function selectVariant(button) {
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;
    variantButtons.forEach((item) => {
      const selected = item === button;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', String(selected));
    });
    selectedVariant = {
      id: Number.parseInt(button.dataset.variantId || '', 10),
      label: button.dataset.variantLabel || button.textContent.trim(),
      image: button.dataset.variantImage || mainImage?.currentSrc || mainImage?.src || '',
      price: Number.parseInt(button.dataset.variantPrice || '0', 10),
    };
    if (mainImage && selectedVariant.image) {
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = selectedVariant.image;
      mainImage.alt = selectedVariant.label;
    }
    if (mainPrice) mainPrice.textContent = formatMoney(selectedVariant.price);
    updateUI();
  }

  function initializeSelection() {
    variantButtons.forEach((button) => {
      button.classList.remove('is-selected');
      button.setAttribute('aria-pressed', 'false');
    });
    const firstAvailableVariant = variantButtons.find((button) => !button.disabled);
    if (firstAvailableVariant) selectVariant(firstAvailableVariant);
    if (variantError) variantError.hidden = Boolean(firstAvailableVariant);

    quantities.forEach((value, gift) => quantities.set(gift, 0));
    updateUI();
  }

  function updateGiftControls() {
    const total = totalQuantity();
    gifts.forEach((gift) => {
      const quantity = quantities.get(gift) || 0;
      const available = gift.dataset.available === 'true';
      const output = gift.querySelector('[data-gpb-quantity]');
      const minus = gift.querySelector('[data-gpb-minus]');
      const plus = gift.querySelector('[data-gpb-plus]');
      const prices = gift.querySelector('[data-gpb-gift-prices]');
      const originalPrice = gift.querySelector('[data-gpb-gift-original-price]');
      const unitPrice = Number.parseInt(gift.dataset.price || '0', 10);
      if (output) output.textContent = String(quantity);
      if (prices) prices.hidden = quantity <= 0;
      if (originalPrice && quantity > 0) originalPrice.textContent = formatMoney(unitPrice * quantity);
      if (minus) minus.disabled = isSubmitting || !available || quantity <= 0;
      if (plus) plus.disabled = isSubmitting || !available || total >= target;
      gift.classList.toggle('is-selected', quantity > 0);
    });
  }

  function appendSummaryImage(src, alt, quantity = 1, isMain = false) {
    if (!summaryProducts || !src) return;
    if (!isMain && summaryProducts.children.length > 0) {
      const plus = document.createElement('span');
      plus.className = 'cv-gpb__summary-plus';
      plus.textContent = '+';
      plus.setAttribute('aria-hidden', 'true');
      summaryProducts.appendChild(plus);
    }
    const item = document.createElement('span');
    item.className = 'cv-gpb__summary-item';
    const image = document.createElement('img');
    image.src = src;
    image.alt = alt;
    image.loading = 'lazy';
    item.appendChild(image);
    if (!isMain && quantity > 1) {
      const badge = document.createElement('span');
      badge.className = 'cv-gpb__summary-qty';
      badge.textContent = `×${quantity}`;
      item.appendChild(badge);
    }
    summaryProducts.appendChild(item);
  }

  function updateSummary() {
    if (!summaryProducts) return;
    summaryProducts.replaceChildren();
    const selectedMainImage = selectedVariant?.image || mainImage?.currentSrc || mainImage?.src || '';
    appendSummaryImage(selectedMainImage, selectedVariant?.label || 'Growth Plan', 1, true);

    let savedCents = 0;
    gifts.forEach((gift) => {
      const quantity = quantities.get(gift) || 0;
      if (quantity <= 0) return;
      const giftImage = gift.querySelector('.cv-gpb__gift-image');
      appendSummaryImage(
        giftImage?.currentSrc || giftImage?.src || '',
        gift.dataset.productTitle || 'Produk gratis',
        quantity
      );
      savedCents += Number.parseInt(gift.dataset.price || '0', 10) * quantity;
    });

    if (packagePrice) {
      packagePrice.textContent = selectedVariant ? formatMoney(selectedVariant.price) : '—';
    }
    if (saving) {
      saving.textContent = `Total Hemat ${formatMoney(savedCents)}`;
    }
  }

  function updateUI() {
    const total = totalQuantity();
    if (counter) {
      counter.textContent = `${total}/${target} dipilih`;
      counter.classList.toggle('is-incomplete', total !== target);
    }
    if (summaryCount) summaryCount.textContent = String(total);
    updateGiftControls();
    updateSummary();
    if (submit) submit.disabled = isSubmitting || !configured || !selectedVariant || total !== target;
  }

  function changeGiftQuantity(gift, delta) {
    if (isSubmitting || gift.dataset.available !== 'true') return;
    const current = quantities.get(gift) || 0;
    const next = current + delta;
    if (next < 0 || next > target) return;
    if (delta > 0 && totalQuantity() >= target) {
      setMessage(`Jumlah hadiah maksimal ${target} produk.`, 'error');
      return;
    }
    quantities.set(gift, next);
    setMessage();
    updateUI();
  }

  function openNow() {
    if (isOpen) return false;
    isOpen = true;
    previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    bodyOverflowBeforeOpen = document.body.style.overflow;
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cv-gpb-open');
    document.body.style.overflow = 'hidden';
    setMessage(configured ? '' : 'Lengkapi pilihan produk di pengaturan tema.', configured ? '' : 'error');
    window.requestAnimationFrame(() => panel?.focus({ preventScroll: true }));
    document.dispatchEvent(new CustomEvent('cv:growth-plan-bundle:opened'));
    return true;
  }

  function suppressOtherMarketingPopups() {
    window.CVGrowthPlanBundleSuppressMarketingPopups = true;
    window.CVPopupManager?.cancel?.('member-cashback');
    window.CVPopupManager?.cancel?.('growth-plan-voucher');
    document.dispatchEvent(new CustomEvent('cv:growth-plan-bundle:suppress-marketing'));
  }

  function requestOpen(reason = 'banner') {
    if (isOpen) return;
    suppressOtherMarketingPopups();
    if (window.CVPopupManager?.request) {
      window.CVPopupManager.request({
        id: managerId,
        priority: 100,
        reason,
        element: popup,
        open: openNow,
      });
    } else {
      openNow();
    }
  }

  function closePopup() {
    if (!isOpen || isSubmitting) return;
    isOpen = false;
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cv-gpb-open');
    document.body.style.overflow = bodyOverflowBeforeOpen;
    window.CVPopupManager?.release?.(managerId);
    previousFocus?.focus?.({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('cv:growth-plan-bundle:closed'));
  }

  function isBundleTrigger(anchor) {
    if (!(anchor instanceof HTMLAnchorElement)) return false;
    try {
      const url = new URL(anchor.href, window.location.href);
      return url.searchParams.get('open') === triggerValue || url.hash === `#${triggerValue}`;
    } catch (error) {
      return false;
    }
  }

  function cleanTriggerFromAddressBar() {
    const url = new URL(window.location.href);
    if (url.searchParams.get('open') !== triggerValue) return;
    url.searchParams.delete('open');
    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
  }

  async function addBundleToCart() {
    if (!submit || submit.disabled || isSubmitting) return;
    const total = totalQuantity();
    if (!selectedVariant) {
      setMessage('Pilih IP Growth Plan terlebih dahulu.', 'error');
      return;
    }
    if (total !== target) {
      setMessage(`Pilih tepat ${target} produk gratis.`, 'error');
      return;
    }

    const bundleId = `CVGP-${Date.now().toString(36).toUpperCase()}`;
    const items = [
      {
        id: selectedVariant.id,
        quantity: 1,
        properties: {
          '_CV Bundle': bundleId,
          '_CV Bundle Role': 'main',
        },
      },
    ];

    gifts.forEach((gift) => {
      const quantity = quantities.get(gift) || 0;
      if (quantity <= 0) return;
      items.push({
        id: Number.parseInt(gift.dataset.variantId || '', 10),
        quantity,
        properties: {
          '_CV Bundle': bundleId,
          '_CV Bundle Role': 'gift',
        },
      });
    });

    isSubmitting = true;
    submit.disabled = true;
    submit.setAttribute('aria-busy', 'true');
    if (submitLabel) submitLabel.textContent = 'Menambahkan Paket...';
    if (spinner) spinner.hidden = false;
    setMessage();
    updateGiftControls();

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Produk tidak dapat ditambahkan.');

      const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = cartResponse.ok ? await cartResponse.json() : null;
      setMessage('Paket berhasil ditambahkan ke keranjang.', 'success');
      isSubmitting = false;
      submit.removeAttribute('aria-busy');
      closePopup();
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart || result,
          sourceId: managerId,
          data: {
            source: managerId,
            itemCount: cart?.item_count ?? (target + 1),
          },
        },
      }));
    } catch (error) {
      isSubmitting = false;
      submit.removeAttribute('aria-busy');
      setMessage(error instanceof Error ? error.message : 'Terjadi kesalahan. Silakan coba lagi.', 'error');
      updateUI();
    } finally {
      if (submitLabel) submitLabel.textContent = defaultSubmitLabel;
      if (spinner) spinner.hidden = true;
      if (!isOpen) updateUI();
    }
  }

  variantButtons.forEach((button) => button.addEventListener('click', () => selectVariant(button)));
  gifts.forEach((gift) => {
    gift.querySelector('[data-gpb-minus]')?.addEventListener('click', () => changeGiftQuantity(gift, -1));
    gift.querySelector('[data-gpb-plus]')?.addEventListener('click', () => changeGiftQuantity(gift, 1));
  });
  closeButtons.forEach((button) => button.addEventListener('click', closePopup));
  submit?.addEventListener('click', addBundleToCart);

  document.addEventListener('click', (event) => {
    const anchor = event.target instanceof Element ? event.target.closest('a') : null;
    if (!isBundleTrigger(anchor)) return;
    event.preventDefault();
    requestOpen('banner');
  });

  document.addEventListener('cv:growth-plan-bundle:open', () => requestOpen('custom-event'));
  document.addEventListener('keydown', (event) => {
    if (!isOpen) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closePopup();
      return;
    }
    if (event.key !== 'Tab' || !panel) return;
    const focusable = Array.from(panel.querySelectorAll(
      'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter((element) => element.getClientRects().length > 0);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  initializeSelection();

  const currentUrl = new URL(window.location.href);
  if (currentUrl.searchParams.get('open') === triggerValue || currentUrl.hash === `#${triggerValue}`) {
    cleanTriggerFromAddressBar();
    window.setTimeout(() => requestOpen('direct-link'), 100);
  }
})();
